// extracted by mini-css-extract-plugin
module.exports = {"container":"FormCheckbox_container__fzE1_"};